import { AfterViewChecked, Component, OnInit, ViewChild } from "@angular/core";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { ArcaLogsModel } from "src/app/models/ArcaLogsModel";
import { ArcaLogsService } from "src/app/services/arca-logs/arcaLogs.service";

@Component({
  selector: "app-logs",
  templateUrl: "./logs.component.html",
  styleUrls: ["./logs.component.scss"],
})
export class LogsComponent implements OnInit, AfterViewChecked {
  constructor(
    private arcaLogsService: ArcaLogsService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {}

  @ViewChild("history_paginator") paginator: MatPaginator;

  tzoffset = new Date().getTimezoneOffset() * 60000;
  localISOTime = new Date(Date.now() - this.tzoffset)
    .toISOString()
    .slice(0, -1);
  date: any = this.localISOTime;

  disable_history_pagination: boolean = true;
  history_loading: boolean = true;

  page: number;
  pageEvent!: PageEvent;
  length!: number;
  pageSize!: number;
  pageIndex!: number;
  paginator_length: 100000;

  arcaLogs: ArcaLogsModel[] = [];

  selectedArcaResponse: any;

  ngAfterViewChecked() {
    try {
      const list = document.getElementsByClassName("mat-paginator-range-label");
      list[0].innerHTML = "Page: " + this.page.toString();
      if (this.page && this.page != 1) {
        this.paginator.pageIndex = this.page - 1;
      }
    } catch {}
  }

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      this.disable_history_pagination = true;
      this.page = parseInt(params.page);
      if (!this.page) {
        this.page = 1;
      }
      this.getArcaLogs();
    });
  }

  getArcaLogs() {
    const searchArcaLogFilters = {
      start: "2020-01-01T10:49:00.795Z",
      end: this.date,
      arca_api_type: "",
    };
    this.arcaLogsService.getLogs(searchArcaLogFilters, this.page).subscribe(
      (res) => {
        this.arcaLogs = res.body as ArcaLogsModel[];

        this.arcaLogs.forEach((al) => {
          if (al?.type == "GetOrderStatusExtended") {
            al.arcaResponse = al?.arcaResponse.replace(
              /("pan":")(\d{6})\*\*(\d{4}")/g,
              "$1********$3"
            );
          }
        });

        this.disable_history_pagination = false;
      },
      (err) => console.log(err)
    );
  }

  getJson(str: string) {
    // console.log(JSON.parse(str));
    return str;
  }

  getSelectedArcaResponse(str: string) {
    this.selectedArcaResponse = JSON.parse(str);
    console.log(this.selectedArcaResponse);
  }

  close() {
    this.selectedArcaResponse = null;
  }

  handlePageEvent(e: PageEvent) {
    this.pageEvent = e;
    this.length = e.length;
    this.pageSize = e.pageSize;
    this.pageIndex = e.pageIndex;

    this.page = this.pageIndex + 1;

    const queryParams: Params = { page: this.page };
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: queryParams,
      queryParamsHandling: "merge", // remove to replace all query params by provided
    });
  }
}
